// ChartComponent.js
import React, { useState } from "react"
import { Chart } from "react-google-charts"
import { GoogleChartWrapperChartType } from "react-google-charts"
import { useTranslation } from "react-i18next"
import { PendingSpinner } from "../Pending"

type ChartOptions = {
  title: string
  chartArea?: { width: string }
  hAxis?: { title: string; logScale?: boolean }
  vAxis?: { title: string }
}

const ChartDashboard = ({
  data,
  handleVisualizationClick,
  projectName,
  ownershipName
}: {
  data: (string | number)[][]
  handleVisualizationClick: () => void
  projectName?: string
  ownershipName?: string
}) => {
  const { t } = useTranslation("tasks")
  const defaultPieChartOptions = {
    title: t("visualization.chartOptionTitle")
  }
  const [chartType, setChartType] = useState<GoogleChartWrapperChartType>("PieChart")
  const [options, setOptions] = useState<ChartOptions>(defaultPieChartOptions)
  const handleChartTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setChartType(event.target.value as GoogleChartWrapperChartType)
    switch (event.target.value) {
      case "PieChart":
        setOptions({
          title: t("visualization.chartOptionTitle")
        })
        break
      case "BarChart":
        setOptions({
          title: t("visualization.chartOptionTitle"),
          chartArea: { width: "50%" },
          hAxis: {
            title: "Count",
            logScale: true // Enables logarithmic scale
          },
          vAxis: {
            title: "Task Type Tag"
          }
        })
        break
      default:
        break
    }
  }
  return (
    <div className="reveal-overlay d-block">
      <div className="reveal-container">
        <div className="reveal overflow-unset" style={{ maxWidth: "80%" }} role="dialog">
          <header className="align-items-start">
            <div style={{ width: "100%" }}>
              <h3>{t("visualization.projectDetails")}</h3>
              <hr />
              <div className="d-flex flex-row justify-content-between align-items-center">
                <div className="d-flex flex-column">
                  <div className="p-1">
                    <b>
                      {t("visualization.name")}: {projectName}{" "}
                    </b>
                  </div>
                  <div className="p-1">
                    <b>
                      {t("visualization.organization")}: {ownershipName}{" "}
                    </b>
                  </div>
                </div>
                {/* Chart type selection dropdown */}
                <div className="d-flex flex-row align-items-center" style={{ width: "40%" }}>
                  <label htmlFor="chartType" style={{ marginRight: "10px", width: "20%" }}>
                    {t("visualization.chartType")}:
                  </label>
                  <select id="chartType" value={chartType} onChange={handleChartTypeChange}>
                    <option value="PieChart">{t("visualization.chartOption1")}</option>
                    <option value="BarChart">{t("visualization.chartOption2")}</option>
                  </select>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="button icon-circle icon-medium tertiary"
              onClick={handleVisualizationClick}
            >
              <i className="icon-font tc-icon-content-close"></i>
            </button>
          </header>
          <div className="scroll-section overflow-unset" style={{ width: "100%", minHeight: "400px" }}>
            {data && data.length > 1 ? (
              <Chart chartType={chartType} data={data} options={options} width="100%" height="400px" />
            ) : (
              // <div className="w-100" style={{ height: "400px" }}>
              <PendingSpinner />
              // </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChartDashboard
